import { render, staticRenderFns } from "./DetailsDialog.vue?vue&type=template&id=8fc7343c&scoped=true"
import script from "./DetailsDialog.vue?vue&type=script&lang=js"
export * from "./DetailsDialog.vue?vue&type=script&lang=js"
import style0 from "./DetailsDialog.vue?vue&type=style&index=0&id=8fc7343c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_71321242e37ff7a0c7584d931db29eba/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fc7343c",
  null
  
)

export default component.exports